import { Route } from '@/app/router'

const Location = () => import('./index.vue')


export default new Route('/locations/:id', Location)
	.as('Dashboard:Location')

